import EfCardCartLists from './EFCardCartLists';
import EfSpec from '@elem/ui/ef-spec';
import { useState, useEffect } from 'react';
import styles from './index.module.scss';
import EfInfoSection from '@elem/ui/ef-info-section';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

export default function TheComp({ callbackCart, bundles }: any) {
    const { t } = useLang('theProduct.ListC');
    const { locale } = useRouter();

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-m" />
            <EfInfoSection title={t('title')} />
            <EfCardCartLists items={bundles} callbackCart={callbackCart} list_name={t('title')} />
            <EfSpec className="spec-x" />
        </div>
    );
}
